import { Component, OnInit } from '@angular/core';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardApiDummyComponent')
@Component({
  selector: 'app-wizard-api-dummy',
  templateUrl: './wizard-api-dummy.component.html',
  styleUrls: ['./wizard-api-dummy.component.css']
})
export class WizardApiDummyComponent implements OnInit, DashboardWidgetContent {

  constructor() { }

  property(): boolean {
    return true;
  }

  configure(setting: any): void {
  }
  
  ngOnInit() {
  }

}
